import { useState, useContext } from "react";

import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Tooltip } from "@material-ui/core";

import { EmissaoContext } from "../contexts/EmissaoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";

import { findSalesByClient } from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository.js";
import { itensNfAutoMontagem } from "../../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import useEmissaoController from "./EmissaoController";
import useCalculosTributacao from "./RulesEmissaoCalculosTributacao";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import Swal from "sweetalert2";
import { getAdditionItems } from "../../../../repositories/qerpapi/erp/nf/v1/DIRepository";
import { findTransportadora } from "../../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";
import { findEstadoById } from "../../../../repository/ERP/prouser/EstadoService";
import SelectErp from "../../../../components/basics/SelectErp";
import { useCallback } from "react";
import { GlobalVariables } from "../../../../GlobalVariables";
import { clientFilterSales } from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { findClientsV3 } from "../../../../repositories/qerpapi/v3/ClienteRepository";

import moment from "moment";
import "moment/locale/pt-br";
import { formatDate } from "../../../../utils/formatDate.js";
import { findFornecedor } from "../../../../repository/ERP/prouser/FornecedorService.js";

export default function useWizardEmissaoController() {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    headerCfop,
    nfeListStockLocation,
    nfeListCfop,
    nfeFinancialIssue,
    setNfeFinancialIssue,
    setMainLoading,
    setNfeMontageType,
    setIdsCrsMontage,
    senderListIndicationIe,
    setNfeMontageSubtype,
    nfeListPaymentMethod,
    montageSelectedItemTaxation,
    setMontageSelectedItemTaxation,
    setHeaderFinnally,
    nfeListFinnally,
    headerTypeNfe,
    nfeListModalities,
    listUf,
    listCounty,
    listViaTransporte,
    diIntermediaryTypeList,
    loading,
    setLoading,
    typeMontage,
    setHeaderCfop,
    senderClifor,
    setSaleFinanceSwitch,
    selectedSupplier,
    setSelectedSupplier,
    selectedPurchaseNf,
    setSelectedPurchaseNf,
    selectedPurchaseItems,
    setSelectedPurchaseItems,
    setIsRuralProducerSender,
    setSenderRuralEstablishment,
    setSenderRuralEstablishmentsList,
    setPurchaseStartDate,
    setPurchaseFinalDate,
  } = useContext(EmissaoContext);

  const { taxations } = useContext(ParametrosProdutoContext);

  const {
    calcsIcmsStTaxations,
    calcsIcmsTaxations,
    calcsIpiTaxations,
    calcsCofinsTaxations,
    calcsPisTaxations,
    calcTotalsNfe,
    returnProductObjectsDi,
  } = useCalculosTributacao();

  const {
    handleSetNfeData,
    clearNfe,
    createPaymentItem,
    createProductItem,
    createChargeItem,
    createProductDi,
    taxationByCompany,
    taxationIsNotCf,
    filterByState,
    handleVerificationDifal,
    getCodeBarProduct,
    getDescriptionProduct,
    returnBuiltNfeItems,
  } = useEmissaoController();

  // Estados utilizados nos dados da emissão padrão da nota
  const [selectedReceiver, setSelectedReceiver] = useState([]);
  const [selectedDemands, setSelectedDemands] = useState([]);
  const [selectedItensDemand, setSelectedItensDemand] = useState([]);

  const [dataRowsClient, setDataRowsClient] = useState([]);
  const [dataRowsDemands, setDataRowsDemands] = useState([]);
  const [dataRowsClients, setDataRowsClients] = useState([]);
  const [dataRowsProducts, setDataRowsProducts] = useState([]);

  // Estados utilizados nos dados da emissão de DI
  const [selectedDI, setSelectedDI] = useState([]);
  const [selectedAdditions, setSelectedAdditions] = useState([]);

  const situations = {
    "00": "Em Carteira",
    10: "Em Cobranca",
    20: "Em cartorio",
    30: "Protestado",
    40: "Liquidado Parcialmente",
    50: "Liquidado Totalmente",
    60: "Desconto de Título - Factoring",
    70: "Baixado",
    80: "Depto Juridico",
    90: "Cancelado",
    99: "Renegociado",
  };

  const verifyFinancialIssue = (isNote) => {
    clearNfe(true);
    if (isNote) {
      setNfeFinancialIssue("NOTA");
      setSaleFinanceSwitch(false);
    } else {
      setNfeFinancialIssue("VENDA");
      setSaleFinanceSwitch(true);
    }

    /* Montagem Automatica */
    setNfeMontageType("A");
    setNfeMontageSubtype(GlobalVariables.nfe.assemblyType.automatic);
  };

  const createReceiverBody = (receiver) => {
    const arrAddress = (receiver.endereco || "").split(",");

    return {
      sender: receiver,
      senderId: receiver.id,
      senderClifor: typeMontage === "DI" || typeMontage === "P" ? "F" : "C",
      senderIe: receiver.ie,
      senderIndicationIe:
        senderListIndicationIe.find(
          (indication) => indication.codigo === receiver.indiedest
        ) || null,
      senderCityCode: receiver.municipio_codigo,
      senderCountryCode: receiver.idpais,
      senderName: receiver.razao,
      senderCnpj: receiver.cpfcnpj,
      senderAddres: arrAddress[0] || "",
      senderNumber: arrAddress[1].trim() || "",
      senderDistrict: receiver.bairro,
      senderCity: receiver.cidade,
      senderCep: receiver.cep,
      senderPhone: `${receiver.ddd1 ? `(${receiver.ddd1})` : ""}${
        receiver.telefone1 ? receiver.telefone1 : ""
      }`,
      senderMail: receiver.email,
      senderUf: receiver.id_estado,
      senderUfLabel: receiver.municipio.estado.estado,
      senderDeliverLocations: receiver.clientesentregas || [],
      headerFinalCostumer: receiver.consumidorfinal,
    };
  };

  const createTransporterBody = (transporter) => ({
    transp: transporter,
    transpAddress: transporter.endereco || "",
    transpCity: transporter.cidade || "",
    transpUf: transporter.estado || { estado: "" },
    transpName: transporter.razao || "",
    transpCnpj: transporter.cnpj_cpf || "",
    transpIe: transporter.inscricao_estadual || "",
    transpRntc: transporter.rntrc || "",
    transpId: transporter.id || "",
    transpCityCode: transporter.municipio_codigo || "",
    transpBoardcar: "",
    transpBoardcarUf: "",
  });

  const createSenderDeliveryBody = (senderDelivery) => {
    const arrAddress = (senderDelivery.endereco || "").split(",");
    const city = listCounty.find(
      (county) => county.codigo === senderDelivery.municipio_codigo
    );

    return {
      senderDeliveryAddress: arrAddress[0] || "",
      senderDeliveryNumber: arrAddress[1] || "",
      senderDeliveryDistrict: senderDelivery.bairro,
      senderDeliveryCep: senderDelivery.cep,
      senderDeliveryComplement: senderDelivery.complemento,
      senderDeliveryCodeCity: senderDelivery.municipio_codigo,
      senderDeliveryCity: city,
      senderDeliveryUf: listUf.find(
        (uf) => uf.codibge.toString() === (city?.estado_codigo || "").toString()
      ),
    };
  };

  const setNfeByDemand = async (
    setOpenModal,
    setOpenWizardVenda,
    isByDevolution = false
  ) => {
    setOpenWizardVenda(false);
    setOpenModal(false);
    setMainLoading(true);

    const itens = [];
    const cobranca = [];
    const volumes = [];
    const vendas = [];
    let transportadora = null;
    /* Verificar */
    const formapagamento = [];
    const finalidadeNota = [];

    const dest = selectedReceiver[0];
    const destinatario = createReceiverBody(dest);

    if (dest.transportadora && selectedDemands.length !== 1) {
      transportadora = createTransporterBody(dest.transportadora);
    } else {
      var rawTransporterBody = await handleSearchTransportadoraById(
        selectedDemands[0].idtransportadoras
      );
      rawTransporterBody.estado = await handleSearchEstadoById(
        rawTransporterBody.id_estado
      );
      transportadora = createTransporterBody(rawTransporterBody);
    }

    let idsCrs = [];
    let cobrancaIndex = 0;
    let pagtoIndex = 0;
    let totalDemands = 0;
    let obsVenda = "";
    let tiposFrete = [];
    let modalidadeTransporte = GlobalVariables.trasportModalities.semOcorrencia;
    let enderecoEntrega = [];

    selectedDemands.forEach((demand, key) => {
      vendas.push(demand.id);

      if (demand.obsnfe) {
        if (obsVenda) {
          obsVenda += `, ${demand.obsnfe}`;
        } else {
          obsVenda += demand.obsnfe;
        }
      }

      if (demand.idclientesentrega && destinatario.senderDeliverLocations) {
        const senderDeliveryLocation = destinatario.senderDeliverLocations.find(
          (location) =>
            (location.id || "").toString() ===
            demand.idclientesentrega.toString()
        );

        if (senderDeliveryLocation) {
          enderecoEntrega = createSenderDeliveryBody(senderDeliveryLocation);
        }
      }

      let cashPayment = true;

      demand.contasreceber.forEach((row, index) => {
        idsCrs.push(row.id);

        const recebimentos = row.recebimentos;

        let valorPago = 0;
        if (recebimentos.length) {
          const payment = recebimentos.find(
            (recebimento) => row.id === recebimento.pivot.idcontasreceber
          );
          valorPago = payment ? payment.pivot.valor : 0;
        }

        if (cashPayment && moment(row.datavencto).isAfter(moment(), "day")) {
          cashPayment = false;
        }

        cobranca.push(
          createChargeItem(
            cobrancaIndex,
            "-",
            MaskService.toMask(
              "decimal",
              parseFloat(row.valordoctooriginal).toFixed(2)
            ),
            row.datavencto,
            row.datavencto.split("-").reverse().join("/"),
            MaskService.toMask("decimal", parseFloat(valorPago).toFixed(2)),
            situations[row.situacaodocto],
            row.situacaodocto,
            false,
            row.id,
            row
          )
        );

        cobrancaIndex++;
      });

      if (demand.vendasformaspagtos.length) {
        demand.vendasformaspagtos.forEach((form) => {
          const foundIndex = formapagamento.findIndex(
            (e) => e.pagtoFormaValue === form.tipopagtos?.codigo_nfce
          );

          /* Atualiza o Item e vai agrupando */
          if (typeof foundIndex === "number" && foundIndex !== -1) {
            let attItem = formapagamento[foundIndex];

            const value =
              MaskService.removeMaskDecimal(attItem.pagtoValor || "0") +
              parseFloat(form.valor || "0");
            attItem.pagtoValor = MaskService.toMask(
              "decimal",
              parseFloat(value).toFixed(2)
            );
            formapagamento[foundIndex] = attItem;
          } else {
            /* Cria um novo item */
            if (form.tipopagtos) {
              const pagtoItem = nfeListPaymentMethod.find(
                (item) => item.value === form.tipopagtos.codigo_nfce
              );

              formapagamento.push(
                createPaymentItem(
                  MaskService.toMask(
                    "decimal",
                    parseFloat(form.valor || "0").toFixed(2)
                  ),
                  pagtoIndex,
                  pagtoItem ? pagtoItem.label : "Outros",
                  pagtoItem ? pagtoItem.value : "99",
                  form.tipopagtos.codigo_nfce === "03" || !cashPayment
                    ? "Pagamento à Prazo"
                    : "Pagamento à Vista",
                  form.tipopagtos.codigo_nfce === "03" || !cashPayment
                    ? "1"
                    : "0"
                )
              );
            } else {
              formapagamento.push(
                createPaymentItem(
                  MaskService.toMask(
                    "decimal",
                    parseFloat(form.valor || "0").toFixed(2)
                  ),
                  pagtoIndex
                )
              );
            }
          }

          pagtoIndex++;
          totalDemands += form.valor;
        });

        if (isByDevolution) {
          formapagamento.length = 0;
          cobranca.length = 0;
          finalidadeNota.push(nfeListFinnally.find((e) => e.value === "4"));
          setHeaderFinnally(nfeListFinnally.find((e) => e.value === "4"));
        }
      }

      if (
        demand.tipofrete &&
        demand.tipofrete.trim() &&
        !tiposFrete.includes(demand?.tipofrete?.trim())
      ) {
        tiposFrete.push(demand.tipofrete.trim());
      }
    });

    if (tiposFrete.length === 1) {
      modalidadeTransporte = nfeListModalities.find(
        (modality) => modality.value === tiposFrete[0]
      );
    }

    /* Guardando Ids Do Contas Para Posterior Atualização */
    setIdsCrsMontage(idsCrs);

    const newTaxation = [...taxations];
    selectedItensDemand.forEach((row, key) => {
      let itemTaxation =
        montageSelectedItemTaxation[row.id]?.[row.precounitario];

      if (itemTaxation) newTaxation.push(itemTaxation);

      if (!itemTaxation) itemTaxation = {};

      let cfopToItem = "";
      if (itemTaxation.cfop) {
        cfopToItem = itemTaxation.cfop;
        row.cfop = itemTaxation.cfop;
      } else {
        cfopToItem = headerCfop;
      }

      const cfopItemList = nfeListCfop.find(
        (value) => cfopToItem === value.cfop
      );

      const stockLocationItemList = nfeListStockLocation.find(
        (value) => row.idlocalestoque === value.id
      );

      // [QES-3431]: até então, não aplicava a máscara decimal para
      // calcular o desconto posteriormente na montagem automática.
      const formattedDiscountRow = {
        ...row,
        desconto: MaskService.toMask(
          "decimal",
          row.desconto ? parseFloat(row.desconto).toFixed(5) : "0.00000",
          5
        ),
      };

      let itemTributacaoSt = itemTaxation.tributacaost?.filter(
        (tri) => tri.ufdestino === row.estado
      );
      itemTaxation.tributacaost = [...itemTributacaoSt];

      /* Get das tributações tratadas*/
      const geralTaxation = {
        taxIcms: calcsIcmsTaxations(itemTaxation, formattedDiscountRow),
        taxIcmsSt: calcsIcmsStTaxations(itemTaxation, formattedDiscountRow),
        taxIpi: calcsIpiTaxations(itemTaxation, formattedDiscountRow),
        taxPis: calcsPisTaxations(itemTaxation, formattedDiscountRow),
        taxCofins: calcsCofinsTaxations(itemTaxation, formattedDiscountRow),
        others: {
          prodCfopItemList: cfopItemList,
          prodLocalEstoque: stockLocationItemList,
        },
      };

      // [QES-3431]: porém, nessa função ele já formata o desconto por si só,
      // então, passo a row original que veio do banco.
      itens.push(createProductItem(key, geralTaxation, row));
    });

    for (const row of itens) {
      const callbackVerificationDifal = await handleVerificationDifal({
        ncm: row.prodNcm,
        cfop: row.prodCfop,
        ufDestino: row.prodFuelUf,
        difalChecked: row.prodDifal,
      });
      itens.prodDifal = [...callbackVerificationDifal.difalUfDestino];
    }
    const totals = calcTotalsNfe(itens);

    if (totals.totalValueNFE && totals.totalValueNFE > totalDemands) {
      formapagamento.push(
        createPaymentItem(
          MaskService.toMask(
            "decimal",
            parseFloat(totals.totalValueNFE - totalDemands).toFixed(2)
          )
        )
      );
    }

    if (nfeFinancialIssue === "NOTA") {
      formapagamento.length = 0;
      formapagamento.push(
        createPaymentItem(
          MaskService.toMask(
            "decimal",
            parseFloat(totals.totalValueNFE).toFixed(2)
          )
        )
      );
    }

    const observacoes = {
      obsTextComplemento: obsVenda,
    };
    const body = {
      itens: itens,
      destinatario: destinatario,
      cobranca: cobranca,
      formapagamento: formapagamento,
      volumes: volumes,
      vendas: vendas,
      transportadora: transportadora,
      observacoes: observacoes,
      transpModality: modalidadeTransporte,
      enderecoEntrega: enderecoEntrega,
      finalidadeNota: finalidadeNota,
    };

    handleSetNfeData(body);
    setMainLoading(false);
  };

  const handleSearchTransportadoraById = async (transpId) => {
    setLoading(true);
    try {
      const callbackTransportadora = await findTransportadora(
        queryParams.empresa_cnpj,
        transpId
      );

      if (callbackTransportadora.data) {
        return callbackTransportadora.data;
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchEstadoById = async (estadoId) => {
    setLoading(true);
    try {
      const callbackEstado = await findEstadoById(
        queryParams.empresa_cnpj,
        estadoId
      );

      if (callbackEstado.data) {
        return callbackEstado.data;
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  //Busca os Pedidos Para a Segunda Etapa
  const handleSearchDemandByClient = useCallback(
    async ({
      idClient,
      usedSales = false,
      clientSalesStartDate,
      clientSalesFinalDate,
    }) => {
      setSelectedDemands([]);
      setLoading(true);
      try {
        if (usedSales) {
          if (!clientSalesStartDate || !clientSalesFinalDate) {
            return notify("Verifique o período informado.");
          } else if (
            moment(clientSalesFinalDate).diff(
              moment(clientSalesStartDate),
              "months",
              true
            ) > 3
          ) {
            return notify("Período informado ultrapassa 3 meses!");
          }
        }

        // Seta todos os pedidos encontrados, para posteriormente
        // filtrá-los apenas na view.
        const callbackSales = await findSalesByClient({
          empresa_cnpj: queryParams.empresa_cnpj,
          idcliente: idClient,
          idempresa: queryParams.empresa_id,
          tipo: typeMontage,
          per_page: 100,
          usedSales,
          startDate: clientSalesStartDate,
          finalDate: clientSalesFinalDate,
        });

        setDataRowsDemands(
          callbackSales.data.map((e) => {
            // se o pedido for faturado, dou o aspecto
            // de linha vermelha na tabela (rowError = true).
            if (e.idsituacao === GlobalVariables.saleSituation.invoiced) {
              return { ...e, rowError: true };
            } else return { ...e };
          })
        );
        setDataRowsProducts([]);
        setSelectedItensDemand([]);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [queryParams.empresa_cnpj, queryParams.empresa_id, setLoading, typeMontage]
  );

  const handleSearchClient = useCallback(
    async (
      textFilter,
      onlyOpenedSales = false,
      origin,
      clientSalesStartDate = "",
      clientSalesFinalDate = ""
    ) => {
      setLoading(true);
      try {
        if (!onlyOpenedSales) {
          if (!clientSalesStartDate || !clientSalesFinalDate) {
            return notify("Verifique o período informado.");
          } else if (
            moment(clientSalesFinalDate).diff(
              moment(clientSalesStartDate),
              "months",
              true
            ) > 3
          ) {
            return notify("Período informado ultrapassa 3 meses!");
          }
        }

        var orWhere = {};
        if (textFilter) {
          const encodedTextFilter = encodeURIComponent(textFilter);

          orWhere = {
            id: textFilter.replace(/[^0-9]/g, "") || "",
            razao: `${encodedTextFilter}`,
            apelido: `${encodedTextFilter}`,
            email: `${encodedTextFilter}`,
            cpfcnpj: `${encodedTextFilter}`,
          };
        }

        const callbackClients = await clientFilterSales(
          queryParams.empresa_cnpj,
          queryParams.empresa_id,
          {
            onlyOpenedSales: onlyOpenedSales ? "S" : "N",
            origin: origin === "V" ? "Venda" : "Devolucao",
            startDate: clientSalesStartDate,
            finalDate: clientSalesFinalDate,
            orWhere,
          }
        );

        if (callbackClients.success) setDataRowsClients(callbackClients.data);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, queryParams.empresa_cnpj, queryParams.empresa_id]
  );

  // Busca os produtos nos pedidos selecionados
  const handleSearchProducts = () => {
    setSelectedItensDemand([]);
    (async () => {
      setLoading(true);
      try {
        let isInterstadualSituation =
          selectedReceiver[0].id_estado !== queryParams.id_estado;

        let tipoDocumento = `${GlobalVariables.taxation.documentType.all},${GlobalVariables.taxation.documentType.invoice}`;
        let tipoDestinatario = `${GlobalVariables.taxation.recipientType.all}`;

        if (selectedReceiver[0]) {
          tipoDestinatario +=
            selectedReceiver[0].simples_nacional === "S"
              ? `,${GlobalVariables.taxation.recipientType.simpleNational}`
              : `,${GlobalVariables.taxation.recipientType.normalRegime}`;
        }

        const products = await itensNfAutoMontagem(
          queryParams.empresa_cnpj,
          queryParams.id,
          {
            ids: selectedDemands.map((i) => i.id),
            orderBy: "vendasitens_id",
            tipoDocumento,
            tipoDestinatario,
          },
          `empresa${
            isInterstadualSituation
              ? ",tributacaointerestadual,tributacaost"
              : ",tributacaost"
          }`
        );

        if (!products?.success) return notify("Falha ao buscar produtos");

        const copy = { ...montageSelectedItemTaxation };

        let notifyTributacao = false;

        products?.data?.forEach((product) => {
          if (!copy[product.id]) {
            copy[product.id] = {};
          }
          product.tributacoes = (product?.tributacoes || []).filter(
            taxationByCompany && taxationIsNotCf
          );

          if (isInterstadualSituation)
            product.tributacoes = product.tributacoes.map((tributacao) => ({
              ...tributacao,
              tributacaointerestadual: filterByState({
                data: tributacao.tributacaointerestadual,
                state: selectedReceiver[0].municipio.estado.estado,
              }),
              tributacaost: filterByState({
                data: tributacao.tributacaost,
                state: selectedReceiver[0].municipio.estado.estado,
              }),
            }));

          copy[product.id][product.precounitario] =
            (product?.tributacoes || []).find(
              (tax) => tax.cfop === headerCfop
            ) || null;

          if (!product.tributacoes.length) {
            notifyTributacao = true;
          }
        });

        if (notifyTributacao) {
          notify(
            "Venda(s) possui produto(s) sem tributação cadastrada.",
            true,
            "warning"
          );
        }

        var unitedProducts = {};
        products?.data?.forEach((product) => {
          let key = `${product.id}|${product.precounitario}|${product.desconto}|${product.complemento}`;

          if (!unitedProducts[key]) {
            let vlrTotalBruto =
              parseFloat(product.qtde) *
              (parseFloat(product.precounitario) *
                parseFloat(product.diporc ? product.diporc / 100 + 1 : 1));
            unitedProducts[key] = {
              ...product,
              key,
              vlr_total: vlrTotalBruto,
              vlr_total_liquido: vlrTotalBruto - parseFloat(product.desconto),
              notSelectable: product.travarnf === "1",
              backgroundColor: product.travarnf === "1" ? "#e2e3e5" : "#fefefe",
            };
          } else {
            let newQuantity =
              parseFloat(unitedProducts[key].qtde) + parseFloat(product.qtde);
            let newDiscount =
              parseFloat(unitedProducts[key].desconto) +
              parseFloat(product.desconto);

            let vlrTotalBruto =
              parseFloat(unitedProducts[key].precounitario) *
              parseFloat(
                unitedProducts[key].diporc
                  ? unitedProducts[key].diporc / 100 + 1
                  : 1
              );

            unitedProducts[key] = {
              ...unitedProducts[key],
              key,
              qtde: newQuantity,
              vlr_total: newQuantity * vlrTotalBruto,
              desconto: newDiscount,
              vlr_total_liquido: newQuantity * vlrTotalBruto - newDiscount,
              notSelectable: product.travarnf === "1",
              backgroundColor: product.travarnf === "1" ? "#e2e3e5" : "#fefefe",
            };
          }
        });
        setMontageSelectedItemTaxation(copy);
        setDataRowsProducts(Object.values(unitedProducts));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  };

  const verifyPartialCharges = () => {
    let financialShip = false;
    selectedDemands.forEach((demand) => {
      demand.contasreceber.forEach((row) => {
        /* Caso seja 'Liquidado Parcialmente' ou Tipo da Nota seja Devolução */
        if (row.situacaodocto === "40" || demand.tipo === "D") {
          financialShip = true;
        }
      });
    });

    return financialShip;
  };

  const getTaxsOptionsList = (taxations) => {
    const filteredTaxations = [];
    let keys = [];

    taxations?.forEach((taxation) => {
      if (
        taxation.cfop &&
        (taxation.idproduto || !filteredTaxations[taxation.cfop])
      )
        filteredTaxations[taxation.cfop] = taxation;
    });

    if (filteredTaxations) {
      taxations = [];
      filteredTaxations.forEach((filteredTaxation) => {
        taxations.push(filteredTaxation);
      });
    }

    if (headerTypeNfe?.value === "S") {
      keys = [4, 5, 6, 7];
    } else if (headerTypeNfe?.value === "E") {
      keys = [1, 2, 3];
    } else {
      return taxations;
    }

    return taxations.filter((tax) =>
      keys.includes(parseInt(parseInt(tax.cfop) / 1000))
    );
  };

  const handleChangeCfop = (e, value) => {
    const copy = { ...montageSelectedItemTaxation };

    if (!copy[value.id]) {
      copy[value.id] = {};
    }

    copy[value.id][value.precounitario] = e;

    if (e) {
      setMontageSelectedItemTaxation(copy);
    }

    return e;
  };

  const calcTotalItens = (key) => {
    let total = 0;
    if (selectedItensDemand.length) {
      selectedItensDemand.forEach((row) => {
        total += parseFloat(row[key]);
      });
    }

    return "R$ " + MaskService.toMask("decimal", parseFloat(total).toFixed(2));
  };

  const handleInterstadualOperation = () => {
    const cfops =
      typeMontage === "V"
        ? GlobalVariables.interstadualCfops.exit
        : GlobalVariables.interstadualCfops.entry;

    Swal.fire({
      title: "Alerta",
      icon: "warning",
      text: "Cliente selecionado tem UF diferente da empresa emitente, portanto, a operação é interestadual. Selecione novo CFOP.",
      input: "select",
      inputOptions: Object.assign({}, ...cfops.map((key) => ({ [key]: key }))),
      inputPlaceholder: "CFOP",
      returnFocus: false,
      showConfirmButton: true,
      confirmButtonText: "Prosseguir",
      allowOutsideClick: false,
      customClass: "interstadualCfop",
      inputValidator: function (value) {
        return new Promise(function (resolve) {
          if (value !== "") {
            resolve();
          } else {
            resolve("Selecione um CFOP para prosseguir");
          }
        });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setHeaderCfop(result.value);
      }
    });
  };

  const handleNextStandard = async (
    demandOptions,
    { setPageProp, setActiveStep, activeStep },
    finalConsumer = false
  ) => {
    setPageProp(0);
    switch (activeStep) {
      case 0:
        if (selectedReceiver.length < 1) {
          return notify("Selecione um Cliente.");
        }

        const receiver = selectedReceiver[0];

        const callbackValidCustomer = await validCustomer(receiver.id);
        if (!callbackValidCustomer) {
          return;
        }

        setSelectedReceiver([
          {
            ...receiver,
            municipio_codigo: callbackValidCustomer.municipio_codigo,
            id_estado: callbackValidCustomer.id_estado,
          },
        ]);

        if (senderClifor === "C" && receiver.alerta_faturamento) {
          await Swal.fire({
            icon: "warning",
            text: `Alerta de Faturamento: ${receiver.alerta_faturamento}`,
            showCloseButton: false,
            allowOutsideClick: false,
          });
        }

        if (receiver.id_estado !== queryParams.id_estado) {
          const firstCharAtCFOP = typeMontage === "V" ? "6" : "2";
          if (headerCfop.toString()[0] !== firstCharAtCFOP)
            handleInterstadualOperation();
        }

        handleSearchDemandByClient({
          idClient: receiver.id,
          clientSalesStartDate: moment()
            .subtract(3, "month")
            .format("YYYY-MM-DD"),
          clientSalesFinalDate: moment().format("YYYY-MM-DD"),
        });

        break;

      case 3:
      case finalConsumer:
        if (selectedReceiver.length < 1) {
          return notify("Selecione um Cliente.");
        }
        break;
      case 1:
        if (selectedDemands.length < 1) {
          return notify("Selecione ao menos um Pedido.");
        }
        let numSemContas = [];
        selectedDemands.forEach((element) => {
          if (!element.finalizadacaixa) {
            numSemContas.push(element.numvenda);
          }
        });
        if (numSemContas.length > 0) {
          return notify(
            `As vendas ${numSemContas.join(
              ", "
            )} ainda não foram finalizadas no caixas.`
          );
        }
        handleSearchProducts();
        break;

      case 2:
        if (selectedItensDemand.length < 1) {
          return notify("Selecione ao menos um Produto");
        }

        // Verifica se todos os produtos selecionados estão com tributação
        if (productsWithoutTax().length)
          return notify("Selecione tributação para todos os produtos");

        // utiliza o primeiro índice do array de tipos
        // passado para o array de wherein para setar
        // o subtipo da montagem.
        setNfeMontageSubtype(demandOptions?.tipo[0]);

        if (verifyPartialCharges()) {
          verifyFinancialIssue(false);
          return;
        }

        // verifico se algum pedido selecionado já está faturado
        // se encontrado, seto o "financialIssue" como "VENDA".
        if (!!selectedDemands.find((demand) => demand.idsituacao === 5)) {
          Swal.fire({
            title: "Alerta",
            icon: "warning",
            text: "Existem vendas já utilizadas selecionadas, portanto, será mantido o financeiro das vendas.",
            showConfirmButton: true,
            confirmButtonText: "Entendido",
            allowOutsideClick: false,
          }).then((res) => {
            if (res.isConfirmed) {
              verifyFinancialIssue(false);
            }
          });
        }
        break;

      default:
        return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const validCustomer = async (customerId) => {
    const callbackCustomer = await findClientsV3({
      fields: ["id_estado", "municipio_codigo"],
      filters: {
        id: `strict:${customerId}`,
      },
    });

    if (!callbackCustomer.success || !callbackCustomer.data.length) {
      notify("Ocorreu um problema ao buscar dados do cliente.");
      return false;
    }

    const customer = callbackCustomer.data[0];
    if (!customer.id_estado || !customer.municipio_codigo) {
      await Swal.fire({
        title: "Alerta",
        icon: "warning",
        text: "É necessário atualizar o cadastro do cliente para prosseguir.",
        showConfirmButton: true,
        confirmButtonText: "Atualizar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      }).then((res) => {
        if (res.isConfirmed) {
          const link =
            queryParams.current_url !== "localhost"
              ? `https://${queryParams.current_url}.qyon.com`
              : `http://localhost`;
          window.open(
            `${link}/zf/sistema/clientes/rcadastro?id=${customerId}`,
            "_blank"
          );
        }
      });
      return false;
    }

    return customer;
  };
  const productsWithoutTax = useCallback(
    () =>
      selectedItensDemand.filter(
        (product) =>
          !montageSelectedItemTaxation[product.id][product.precounitario]
      ),
    [montageSelectedItemTaxation, selectedItensDemand]
  );

  const handleBackStandard = ({ setPageProp, setActiveStep }) => {
    setPageProp(0);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleBackDI = ({ setPageProp, setActiveStep }) => {
    setPageProp(0);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setSelectedAdditions([]);
  };

  const columnsClienteSearch = [
    { label: "CÓD.", id: "id", style: { minWidth: 30 } },
    { label: "Nome", id: "razao", style: { minWidth: 500 }, align: "center" },
    {
      label: "Fantasia",
      id: "apelido",
      style: { minWidth: 500 },
      align: "center",
    },
    {
      label: "CNPJ/CPF",
      id: "cpfcnpj",
      style: { minWidth: 300 },
      align: "center",
    },
    {
      label: "Telefone",
      id: "telefone1",
      style: { width: 300 },
      align: "center",
    },
    {
      label: "Cidade",
      id: "cidade",
      style: { minWidth: 300 },
      align: "center",
    },
    { label: "CEP", id: "cep", style: { minWidth: 200 }, align: "center" },
  ];

  const columnsItensSearch = [
    {
      label: "Produto",
      id: "descricao",
      style: { minWidth: 200 },
      format: (value) => {
        const description = getDescriptionProduct(
          value,
          "WizardEmissaoController"
        );
        var statusMsg = "";
        var color = "";

        if (value.tipovenda === "devolucao" || value.tipovenda === "defeito") {
          statusMsg = "Devolução / Defeito";
          color = "red";
        } else if (value.travarnf === "1") {
          statusMsg = "Produto travado no cadastro";
          color = "yellow";
        } else if (value.reclassificado === "S") {
          statusMsg = "Produto reclassificado";
          color = "#A52A2A";
        }
        if (statusMsg) {
          return (
            <>
              <Tooltip title={statusMsg} aria-label={statusMsg}>
                <span style={{ pointerEvents: "all" }}>
                  <FiberManualRecordIcon style={{ color: color }} />
                </span>
              </Tooltip>
              <span style={{ paddingLeft: "4px", verticalAlign: "super" }}>
                {description}
              </span>
            </>
          );
        } else {
          return description;
        }
      },
    },
    {
      label: "Codigo",
      format: (value) => {
        return <>{getCodeBarProduct(value, "WizardEmissaoController")}</>;
      },
    },
    { label: "NCM", id: "ncm" },
    {
      label: "CFOP",
      align: "center",
      style: { minWidth: 140 },
      format: (value) => {
        let cfopValue =
          montageSelectedItemTaxation[value.id]?.[value.precounitario] ||
          handleChangeCfop(
            (value?.tributacoes.length === 1 &&
              getTaxsOptionsList(value?.tributacoes || [])[0]) ||
              null,
            value
          ) ||
          null;

        const cfopBackgroundColor = () => {
          if (!!cfopValue) {
            if (parseInt(cfopValue.cfop) === parseInt(headerCfop))
              return "#bcdccf";
            else return "#fff9b3";
          } else {
            return "rgba(244, 89, 100, 0.3)";
          }
        };

        return (
          <SelectErp
            onChange={(e) => handleChangeCfop(e, value)}
            variant="outlined"
            optionsList={getTaxsOptionsList(value?.tributacoes || [])}
            descriptionField="cfop"
            value={cfopValue}
            style={{ backgroundColor: cfopBackgroundColor() }}
          />
        );
      },
    },
    {
      label: "Qtde",
      format: (value) =>
        value.qtde
          ? MaskService.toMask("decimal", parseFloat(value.qtde).toFixed(3), 3)
          : "-",
    },
    {
      label: "Vlr Unitário",
      style: { minWidth: 105 },
      format: (value) =>
        `R$ ${
          value.precounitario
            ? MaskService.toMask(
                "decimal",
                (
                  parseFloat(value.precounitario) *
                  parseFloat(value.diporc ? value.diporc / 100 + 1 : 1)
                ).toFixed(2)
              )
            : "-"
        }`,
    },
    {
      label: "Vlr Total",
      style: { minWidth: 105 },
      format: (value) =>
        `R$ ${
          value.vlr_total
            ? MaskService.toMask(
                "decimal",
                parseFloat(value.vlr_total).toFixed(2)
              )
            : "-"
        }`,
    },
    {
      label: "Vlr Desconto",
      style: { minWidth: 135 },
      format: (value) =>
        `R$ ${
          value.desconto
            ? MaskService.toMask(
                "decimal",
                parseFloat(value.desconto).toFixed(2)
              )
            : "0,00"
        }`,
    },
    {
      label: "Vlr Liquido",
      style: { minWidth: 105 },
      format: (value) =>
        `R$ ${
          value.vlr_total_liquido
            ? MaskService.toMask(
                "decimal",
                parseFloat(value.vlr_total_liquido).toFixed(2)
              )
            : "0,00"
        }`,
    },
    {
      label: "Complemento",
      format: (value) => value?.complemento || "-",
    },
  ];

  const columnsPedidoSearch = [
    { label: "Nro Venda", id: "numvenda" },
    {
      label: "Total",
      format: (value) =>
        `R$ ${MaskService.toMask(
          "decimal",
          parseFloat(value.totalgeral).toFixed(2)
        )}`,
    },
    { label: "Status", id: "statusvenda" },
    {
      label: "Data da Venda",
      id: "data",
      format: (value) => {
        return value.data.split("-").reverse().join("/");
      },
    },
  ];

  const columnsDITable = [
    {
      label: "Número da DI",
      id: "numerodi",
    },
    {
      label: "Fornecedor",
      id: "fornecedor",
      format: (value) => value.dicontrole?.fornecedor?.razao || "-",
    },
    {
      label: "Data de Desembaraço",
      id: "datadesembaraco",
      format: (value) =>
        new Date(value.datadesembaraco).toLocaleDateString("pt-BR"),
    },
  ];

  const columnsAdditions = [
    {
      label: "Nº Adição",
      id: "numero",
    },
    {
      label: "NCM",
      id: "ncm",
    },
    {
      label: "CFOP",
      id: "cfop",
    },
    {
      label: "Qtd. Itens",
      id: "qtdItens",
    },
    {
      label: "Alíquota ICMS",
      id: "aliqicms",
      format: (value) =>
        `${
          Number.isInteger(parseFloat(value.aliqicms || 0))
            ? parseInt(value.aliqicms)
            : value.aliqicms
        } %`,
    },
  ];

  const handleNextDI = ({
    setPageProp,
    setActiveStep,
    activeStep,
    setOpenModal,
    setOpenWizardVenda,
  }) => {
    setPageProp(0);
    switch (activeStep) {
      case 0:
        if (!selectedDI.length) {
          return notify("Selecione uma DI.");
        }
        setSelectedAdditions(selectedDI[0].diadicao);
        break;

      case 1:
        if (!selectedAdditions.length) {
          return notify("Selecione ao menos uma Adição.");
        }
        setNfDataByDI(
          {
            di: selectedDI[0],
            additions: selectedAdditions,
          },
          setOpenModal,
          setOpenWizardVenda
        );
        break;

      default:
        console.error("Passo não encontrado.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const setNfDataByDI = async (
    additionsInfo,
    setOpenModal,
    setOpenWizardVenda
  ) => {
    setOpenModal(false);
    setOpenWizardVenda(false);

    try {
      setMainLoading(true);

      const CFOP = additionsInfo.di.dicontrole?.cfop?.cfop || "";

      let supplier = additionsInfo.di.dicontrole?.fornecedor || null;
      if (!supplier)
        notify("Não foi encontrado um fornecedor vinculado a DI selecionada.");
      // adaptação dos dados para que se encaixem na
      // função de setar os dados do cliente
      // (que no caso da DI é o fornecedor)
      else
        supplier = createReceiverBody({
          ...supplier,
          cpfcnpj: supplier.cgc,
          email: supplier.email1,
          endereco: `${supplier.endereco}, ${supplier.numero}`,
        });
      let transporter = additionsInfo.di.dicontrole?.transportadora || null;

      if (transporter) {
        transporter = createTransporterBody({
          ...transporter,
        });
      }

      let ids = additionsInfo.additions.map((e) => e.id).join(",");
      const additionItems = await getAdditionItems({
        empresa_cnpj: queryParams.empresa_cnpj,
        ids,
      });

      let items = [];
      if (!additionItems.success) notify("Mercadorias não encontradas.");
      else if (!additionItems?.data) notify("Di sem Mercadorias!");
      else {
        items = additionItems.data.map((product, key) => {
          const listObjects = returnProductObjectsDi(product);

          return {
            ...createProductDi(
              key,
              { ...product, cfop: CFOP, ...listObjects },
              selectedDI[0]
            ),
          };
        });
      }

      let body = {
        // Dados enviados diretamente para a função
        // 'handleSetNfeData', para evitar o import
        // de mais estados, estão dentro de 'notafiscal'

        /* DI */
        dadosDi: {
          diControle: additionsInfo.di.dicontrole,
          diNumeroRegistro: selectedDI[0].numerodi || "",
          diDataRegistro: selectedDI[0].dataregistro || "",
          diUfDes: selectedDI[0].urf_despacho_estado_id
            ? listUf.find(
                (uf) =>
                  uf.id === selectedDI[0].urf_despacho_estado_id.toString()
              )
            : null,
          diLocalDes: selectedDI[0].urfdespachonome || "",
          diDataDes: selectedDI[0].datadesembaraco || "",
          diDrawback: selectedDI[0].nro_drawback || "",

          diImpWayOf: selectedDI[0].viatransportecodigo
            ? listViaTransporte.find(
                (way) => way.value === Number(selectedDI[0].viatransportecodigo)
              )
            : null,
          diIntermediaryType: selectedDI[0].dicontrole?.tipo_importacao
            ? diIntermediaryTypeList.find(
                (way) =>
                  way.value === Number(selectedDI[0].dicontrole.tipo_importacao)
              )
            : null,
          diAcquirerUf: selectedDI[0].dicontrole?.estado_id
            ? listUf.find(
                (uf) => uf.id === selectedDI[0].dicontrole.estado_id.toString()
              )
            : null,
          diAcquirerDocument: selectedDI[0].dicontrole?.cnpj_adquirente || "",
        },

        notafiscal: {
          nfeMontageSubtype: "DI",
          headerIssueType: queryParams.tipoemissaonfe,
          visualizationOnly: true,
          headerCfop: CFOP,
          headerOperation: {
            label: "Operação com exterior",
            value: "3",
          },
          headerTypeNfe: {
            label: "Entrada",
            value: "E",
          },
          transpModality: additionsInfo.di.dicontrole?.modalidade_frete
            ? nfeListModalities.find(
                (modality) =>
                  modality.value ===
                  additionsInfo.di.dicontrole.modalidade_frete.toString()
              )
            : nfeListModalities.find((modality) => modality.value === "9"),
        },
        destinatario: supplier,
        observacoes: {
          obsTextComplemento: additionsInfo.di.dicontrole?.obs_nfe || "",
        },
        transportadora: transporter,
        formapagamento: [
          {
            index: 0,
            pagtoBandeiraLabel: "",
            pagtoBandeiraValue: "",
            pagtoCnpjCred: "",
            pagtoCodigoCartao: "",
            pagtoFormaLabel: "Sem pagamento",
            pagtoFormaValue: "90",
            pagtoIndicadorLabel: "Pagamento à Vista",
            pagtoIndicadorValue: "0",
            pagtoIntLabel: "",
            pagtoIntValue: "",
            pagtoTroco: "0,00",
            pagtoValor: "0,00",
          },
        ],
        itens: items,
        cobranca: [],
        volumes: [],
        vendas: [],
      };

      setNfeMontageType("A");
      handleSetNfeData(body);
    } catch (e) {
      console.error(e);
    } finally {
      setMainLoading(false);
    }
  };

  const handleNextNfePurchase = ({
    setActiveStep,
    activeStep,
    setOpenModal,
    setOpenWizardCompra,
  }) => {
    switch (activeStep) {
      case 0:
        if (!selectedSupplier.length) {
          return notify("Selecione um Fornecedor.", true, "warning");
        }
        break;

      case 1:
        if (!selectedPurchaseNf.length) {
          return notify("Selecione ao menos uma Nota Fiscal.", true, "warning");
        }
        break;

      case 2:
        if (!selectedPurchaseItems.length) {
          return notify("Selecione ao menos um produto.", true, "warning");
        }

        const withoutTax = selectedPurchaseItems.find(
          (product) => !product.cfop
        );

        if (withoutTax) {
          return notify(
            "Selecione tributação para todos os produtos.",
            true,
            "warning"
          );
        }

        setNfeDataByPurchase();
        setOpenModal(false);
        setOpenWizardCompra(false);
        break;

      default:
        console.error("Passo não encontrado.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBackPurchase = ({ setActiveStep }) => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const setNfeDataByPurchase = async () => {
    try {
      const hasDifferentRegime = selectedPurchaseNf.find(
        (nf) => nf.regime !== queryParams.crt
      );

      if (hasDifferentRegime) {
        await Swal.fire({
          icon: "info",
          text: "Identificamos que o regime tributário da nota original difere do regime tributário atual de sua empresa. Recomendamos revisar todos os itens da nota fiscal para garantir a conformidade com o regime tributário atual.",
          confirmButtonText: "OK",
          showConfirmButton: true,
        });
      }

      setMainLoading(true);

      const firstNf = selectedPurchaseNf[0];

      const callbackDestinatario = await findFornecedor(
        queryParams.empresa_cnpj,
        selectedSupplier[0].id,
        "municipio.estado,estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
      );

      if (!callbackDestinatario.success)
        return notify(
          "Não foi possível recuperar as informações do fornecedor. Caso o problema persista entre em contato com o time de suporte!"
        );

      // Estabelecimento Rural

      const destinatario = callbackDestinatario.data;
      const isRuralProducer = destinatario?.produtor_rural;

      setIsRuralProducerSender(!!isRuralProducer);
      setSenderRuralEstablishment(null);
      setSenderRuralEstablishmentsList(
        destinatario?.estabelecimentos_rurais || []
      );

      let supplier = destinatario;

      supplier = createReceiverBody({
        ...supplier,
        cpfcnpj: supplier?.cgc || "",
        email: supplier?.email1 || "",
        endereco: `${supplier?.endereco || ""}, ${supplier?.numero || ""}`,
      });

      const finalidadeNota = [];

      finalidadeNota.push(nfeListFinnally.find((e) => e.value === "4"));
      setHeaderFinnally(nfeListFinnally.find((e) => e.value === "4"));

      const taxNoteAccessKeys = (selectedPurchaseNf || []).map(
        (taxNote) => taxNote?.numero
      );

      const observacoes = {
        obsText: "",
        obsTextCFOP: "",
        obsTextCreditRate: "",
        obsTextComplemento: `Devolução referente NFe (s): ${taxNoteAccessKeys.toString()}`,
      };

      const nfsRefs = [];

      selectedPurchaseNf.forEach((nf, key) => {
        const nfKey = (nf?.chaveacesso || "").trim();

        if (nfKey) {
          nfsRefs.push({
            index: key,
            docChaveAcesso: nf.chaveacesso || "",
            docModeloLabel: "NFe",
            docModeloValue: "55",
            refDocSerie: "",
            refDocNumber: "",
            refDocIssueDate: "",
          });
        }
      });

      let itens = [];
      const formatedItens = selectedPurchaseItems.map((item) => {
        let cstIcms = "";

        if (queryParams.crt === firstNf?.regime) {
          cstIcms = item.cst_icms;
        } else {
          if (queryParams.crt === "3") {
            cstIcms = "90";
          } else {
            cstIcms = "900";
          }
        }

        let modBcIcmsSt = (item?.mod_bc_icms_st || "").trim();
        let modBcIcms = (item?.mod_bc_icms || "").trim();

        let orginValue = (item?.origem || "").trim();

        const vlBcIcms =
          ((item?.vl_bc_icms || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlDesconto =
          ((item?.vl_desconto || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlDespAduII =
          ((item?.vl_desp_adu_ii || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlFrete =
          ((item?.vl_frete || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlIcms =
          ((item?.vl_icms || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlOutras =
          ((item?.vl_outras || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);
        const vlSeguro =
          ((item?.vl_seguro || 0) / (item?.originalQuantity || 0)) *
          (item?.quantidade || 0);

        return {
          ...item,
          id: null,
          origem: orginValue || "0",
          cst_icms: cstIcms,
          mod_bc_icms: modBcIcms,
          mod_bc_icms_st: modBcIcmsSt,
          p_mva_icms_st: 0,
          p_red_bc_icms_st: 0,
          cst_ipi: "53",
          p_ipi: 0,
          cst_pis: "49",
          p_pis: 0,
          cst_cofins: "49",
          p_cofins: 0,
          vl_aliq_pis: 0,
          vl_aliq_cofins: 0,
          p_icms_st: 0,
          vl_bc_cofins: 0,
          vl_bc_icms: vlBcIcms,
          vl_bc_icms_st: 0,
          vl_bc_icms_st_ret: 0,
          vl_bc_ii: 0,
          vl_bc_ipi: 0,
          vl_bc_pis: 0,
          vl_cofins: 0,
          vl_cred_icms_sn: 0,
          vl_desconto: vlDesconto,
          vl_desp_adu_ii: vlDespAduII,
          vl_frete: vlFrete,
          vl_icms: vlIcms,
          vl_icms_st: 0,
          vl_icms_st_ret: 0,
          vl_ii: 0,
          vl_iof_ii: 0,
          vl_ipi: 0,
          vl_outras: vlOutras,
          vl_pis: 0,
          vl_seguro: vlSeguro,
          dadosadicionais: "",
          extipi: "",
          motdesicms: "",
          p_icmsdif: "",
          p_icms_interna_destino: "",
          p_icms_interestadual: "",
          p_icms_fcp: "",
          cenq: "",
          imp_thc_capatazia: 0,
          imp_taxa_siscomex: 0,
          imp_afrmm: 0,
          imp_fob: 0,
          imp_peso: 0,
          imp_frete_ii: 0,
          imp_seguro_ii: 0,
          imp_aduaneiro_ii: 0,
          imp_outrasdespesas_ii: 0,
          imp_unitario_ii: 0,
          vl_alq_ii: 0,
          vl_alq_red_ii: 0,
        };
      });

      itens = returnBuiltNfeItems({ itens: formatedItens });

      setSaleFinanceSwitch(false);
      setNfeFinancialIssue("NOTA");

      let modalidadeTransporte =
        GlobalVariables.trasportModalities.semOcorrencia;

      if ((firstNf?.tipofrete || "").trim()) {
        modalidadeTransporte = nfeListModalities.find(
          (modality) => modality.value === firstNf.modalidadefrete
        );
      }

      const body = {
        notafiscal: {
          nfeMontageSubtype: "D",
          headerIssueType: queryParams.tipoemissaonfe,
          nfeStatus: "D",
          headerIssueTime: new Date(),
          headerTime: null,
          headerIeTax: firstNf.iest || "",
          headerDateJL: formatDate({
            date: new Date(),
            separator: "-",
            format: "yyyy-mm-dd",
          }),
          headerOperation: {
            label: "Operação interna",
            value: "1",
          },
          headerTypeNfe: {
            label: "Saida",
            value: "S",
          },
        },
        itens: itens,
        destinatario: supplier,
        cobranca: [],
        formapagamento: [],
        volumes: [],
        vendas: [],
        transportadora: null,
        observacoes: observacoes,
        transpModality: modalidadeTransporte,
        nfsRefs: nfsRefs,
        enderecoEntrega: [],
        finalidadeNota: finalidadeNota,
      };

      setNfeMontageType("A");
      setSelectedSupplier([]);
      setSelectedPurchaseNf([]);
      setSelectedPurchaseItems([]);
      setPurchaseStartDate("");
      setPurchaseFinalDate("");
      handleSetNfeData(body);
    } catch (error) {
      notify(
        "Não foi possível concluir a montagem automática. Caso o problema persista, entre em contato com o time de suporte!"
      );
      console.error("Automatic Purchase Nfe Error: ", error);
    } finally {
      setMainLoading(false);
    }
  };

  return {
    handleSearchDemandByClient,
    handleSearchClient,
    handleSearchProducts,
    verifyFinancialIssue,
    setNfeByDemand,
    loading,
    setLoading,
    selectedReceiver,
    setSelectedReceiver,
    selectedDemands,
    setSelectedDemands,
    selectedItensDemand,
    setSelectedItensDemand,
    dataRowsClient,
    setDataRowsClient,
    dataRowsDemands,
    setDataRowsDemands,
    dataRowsClients,
    setDataRowsClients,
    dataRowsProducts,
    setDataRowsProducts,
    verifyPartialCharges,
    getTaxsOptionsList,
    handleChangeCfop,
    calcTotalItens,
    handleNextStandard,
    handleBackStandard,
    columnsClienteSearch,
    columnsPedidoSearch,
    columnsItensSearch,
    productsWithoutTax,

    columnsAdditions,
    columnsDITable,
    selectedDI,
    setSelectedDI,
    selectedAdditions,
    setSelectedAdditions,
    handleNextDI,
    handleBackDI,
    handleNextNfePurchase,
    handleBackPurchase,
    setNfeDataByPurchase,
  };
}
